import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";

const SpinnerCentered = (_props) => {
  return (
    <Grid
      container
      direction="row"
      sx={{ justifyContent: "center", alignItems: "center" }}
    >
      <Grid size={12}>
        <CircularProgress />
      </Grid>
    </Grid>
  );
};

export default SpinnerCentered;
